// extracted by mini-css-extract-plugin
export default {"results_info_container":"TableResultsInfo_results_info_container__T9jLg","results_pp":"TableResultsInfo_results_pp__FiTbv","active_page":"TableResultsInfo_active_page__8pUmS"};